angular.module('bribac.components.inactiveDaysEditor', [
    'bribac.translations',
    'bribac.entities.kinds',
    'bribac.services.api',
    'bribac.services.inactiveDaysStatusEditorModal',
    'bribac.services.errorUtils',
    'bribac.decorator.uibDatePicker'
  ])
  .component('inactiveDaysEditor', {
    templateUrl: 'inactive-days-editor-component.html',
    controller: 'InactiveDaysEditorCtrl',
    bindings: {
      inactiveDays: '<',
      successCallback: '<',
      cancelCallback: '<',
      subject: '<'
    }
  })

  .controller('InactiveDaysEditorCtrl', function(
    $scope,
    $translate,
    api,
    inactiveDaysStatusEditorModal,
    errorUtils
  ) {

    var $ctrl = this

    var now = new Date()
    var tomorrow = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1)
    var isoStringMillisecondsRegex = /\.\d{3}/
    $ctrl.selectedInactiveDays = []
    $ctrl.inactiveDays =[]
    $ctrl.deletedInactiveDays = []

    $ctrl.$onInit = function() {
      getSelectedMonthInactiveDays(now)
    }

    $ctrl.showInactiveDaysStatusEditorModal = function() {
      inactiveDaysStatusEditorModal.openModal(function saveSuccess(data) {
        var daysToSetInactive = data.filter(function (day) {
          return !dayAlreadyInactive(day)
        })
        addInactiveDays($ctrl.subject.id,{inactiveDays: daysToSetInactive})
      })
    }

    $scope.$watch('$ctrl.date', function(newVal) {
      if(newVal && $ctrl.selectedInactiveDays) {
        if(containsSelectedDate(newVal)) {
            deleteInactiveDay(newVal)
        } else {
            $ctrl.selectedInactiveDays.push(newVal)
            $scope.$broadcast('refreshDatepicker')
        }
      }
    })

    $scope.options = {
      customClass: getDayClass,
      minDate: tomorrow
    };

    function getDayClass(data) {
      var date = data.date;
      if(containsSelectedDate(date)) {
          return 'inactive';
      }
      return '';
    }

    function containsSelectedDate(date) {
      var days = $ctrl.selectedInactiveDays.filter(function(selectedDay){
        return new Date(selectedDay).setHours(0,0,0,0) === new Date(date).setHours(0,0,0,0)
      })
      return days.length != 0
    }

    // deleting date locally from array
    function deleteDate(date) {
      for (var i = 0; i < $ctrl.selectedInactiveDays.length; i++) {
        if (new Date($ctrl.selectedInactiveDays[i]).setHours(0,0,0,0) === new Date(date).setHours(0,0,0,0)) {
            delete $ctrl.selectedInactiveDays[i]
            $scope.$broadcast('refreshDatepicker')
            break
        }
      }
    }

    // searching selected day from inactive days list and get id of the inactive to delete from server
    function deleteInactiveDay(date) {
      for (var i = 0; i < $ctrl.inactiveDays.length; i++) {
        var day = $ctrl.inactiveDays[i]
        if (new Date(day.day).setHours(0,0,0,0) === new Date(date).setHours(0,0,0,0)) {
          // Adding all deleted ids in a list
          $ctrl.deletedInactiveDays.push(day.id)
           break
        }
      }
      deleteDate(date)
    }

    //Api call for deleting inactive day
    function deleteInactiveDays(subjectId, inactiveDayId) {
      api.deleteInactiveDay(subjectId, inactiveDayId)
          .then(function success(request) {
      })
    }

    function dayAlreadyInactive(date) {
      var days = $ctrl.copyOfInactiveDays.filter(function(selectedDay) {
        return new Date(selectedDay).setHours(0,0,0,0) === new Date(date).setHours(0,0,0,0)
      })
      return days.length != 0
    }

    //Api call for adding inactive days
    function addInactiveDays(subjectId, inactiveDaysList) {
      var $form = $ctrl.form
      $form._submitError = ''
      $form._submitting = true
      api.addInactiveDay(subjectId, inactiveDaysList)
          .finally(function() { $form._submitting = false })
          .then(function succes(response) {
            $form._submitError = errorUtils.parseErrorResponse(response)
            if(response.status == 200) {
              $ctrl.successCallback(response.data.inactiveDays)
            }
      })
    }

    $ctrl.saveInactiveDays = function() {
      var daysToSetInactive = $ctrl.selectedInactiveDays.filter(function (day) {
        return !dayAlreadyInactive(day)
      })
      addInactiveDays($ctrl.subject.id,{inactiveDays: daysToSetInactive})
      if($ctrl.deletedInactiveDays.length)
        deleteInactiveDays($ctrl.subject.id, {inactiveDayIds: $ctrl.deletedInactiveDays})
    }

    $scope.$on('monthChanged', function(event, date) {
      if(!inactiveDaysStatusEditorModal.isOpen() && date) {
        getSelectedMonthInactiveDays(date)
      }
    });

    function getSelectedMonthInactiveDays(date){
      $ctrl.firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
      $ctrl.lastDay = new Date(date.getFullYear(), date.getMonth() + 1);
      getInactiveDays($ctrl.subject.id, $ctrl.firstDay, $ctrl.lastDay)
    }

    //Get Inactive days of subject between a date range
    function getInactiveDays(subjectId, fromDate, toDate) {
      $ctrl.inactiveDaysPromise = api.getInactiveDays(subjectId,
      fromDate.toISOString().replace(isoStringMillisecondsRegex, ''),
      toDate.toISOString().replace(isoStringMillisecondsRegex, ''))
        .then(function success(request) {
          if(request.status == 200) {

            // Add all months data in a list, on month change preserve previous months data
            for (var i = 0; i < request.data.length; i++) {
              var date = request.data[i];
              var found = Object.values($ctrl.inactiveDays).find( function(day) {
                 return (new Date(day.day).setHours(0, 0, 0, 0) == new Date(date.day).setHours(0, 0, 0, 0))
              })
              if(!found) {
                $ctrl.inactiveDays.push(date)
              }
            }

            //converting 'inactive day objects array' into an array with having only days
            $ctrl.copyOfInactiveDays = $ctrl.inactiveDays.map( function (days) {
              return days.day
            })
            if($ctrl.selectedInactiveDays && $ctrl.copyOfInactiveDays) {
              for (var i = 0; i < $ctrl.copyOfInactiveDays.length; i++) {
                var date = $ctrl.copyOfInactiveDays[i];
                if(!$ctrl.selectedInactiveDays.includes(new Date(date).setHours(0, 0, 0, 0))) {
                  $ctrl.selectedInactiveDays.push(date)
                }
              }
            }
            $scope.$broadcast('refreshDatepicker')
          }
      })
    }

  });